<template>
    <div>
        <h2 class="mb-3" v-html="$t('intern_userdata.change_pw')"></h2>
        <div class="alert alert-danger" v-if="error">
            {{error}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form @submit.prevent="submit">
            <div class="form-group">
                <label for="old_pass">Altes Passwort</label>
                <input type="password" v-model.trim="old_pass" @blur="$v.old_pass.$touch()" id="old_pass" :class="[{ 'is-invalid': $v.old_pass.$error } , {'is-invalid': initialErrorOldPass }]" class="form-control" placeholder="Altes Passwort eingeben">
                <div class="invalid-feedback" v-if="!$v.old_pass.required">Sie müssen das alte Passwort eingeben</div>
            </div>
            <div class="form-group">
                <label for="pass">Neues Passwort</label>
                <input type="password" v-model.trim="pass" id="pass" :class="[{ 'is-invalid': $v.repass.$error} , {'is-invalid': initialErrorPass }]" class="form-control" placeholder="Passwort eingeben">
                <div class="invalid-feedback" v-if="!$v.repass.sameAsPass">Passwörter stimmen nicht überein</div>
            </div>
            <div class="form-group">
                <label for="repass">Passwort wiederholen</label>
                <input type="password" v-model.trim="repass" @blur="$v.repass.$touch()" id="repass" :class="[{ 'is-invalid': $v.repass.$error} , {'is-invalid': initialErrorPass }]" class="form-control" placeholder="Passwort wiederholen">
                <div class="invalid-feedback" v-if="!$v.repass.sameAsPass">Passwörter stimmen nicht überein</div>
            </div>
            <div class="mt-3">
                <button class="btn btn-success" >Speichern</button>
            </div>
        </form>
        <loading v-if="loading"/>
        <b-toast id="my-toast" variant="success" solid>
            {{success}}
        </b-toast>
    </div>
</template>

<script>
    import { required, sameAs } from 'vuelidate/lib/validators';

    export default {
        name: 'konto-zugang',
        data() {
            return {
                old_pass: '',
                pass: '',
                repass: '',
                loading: false,
                success: '',
                error: '',
                initialErrorPass : '',
                initialErrorOldPass : ''
            }
        },
        methods: {
            submit() {
                this.error = '';
                this.$v.$touch();
                if(!this.$v.$invalid){

                    this.loading = true;
                    const data = {
                        old_pass: this.old_pass,
                        pass: this.pass,
                        repass: this.repass
                    };
                    this.$http.post('/userApi/changeCredintials', data).then(response => {
                        this.loading = false;
                        if(response.status == 'success'){
                            let data = JSON.parse(response.data);
                            this.error   = '';
                            this.success = data.msg;
                            this.$bvToast.show('my-toast');
                            this.$store.dispatch('LOGIN_USER');
                            this.error   = '';
                            setTimeout(() => {
                              location.href  = '/intern/inserat/uebersicht/1';
                            }, 3000)
                        }
                    }).catch(error => {
                        console.log(error);
                        //this.$v.repass.$touch();
                        //this.$v.repass.$error = true;
                        let data = JSON.parse(error.response.data.data);
                        this.error = data.msg;
                        if(this.error == 'Bitte füllen Sie alle Felder aus'){
                          this.initialErrorPass = true;
                        }
                        if(this.error == 'Altes Passwort nicht korrekt') {
                          this.initialErrorOldPass =true;
                        }
                        this.loading = false;

                    });
                }
            }
        },
        created() {
            document.title = 'Meine Zugangsdaten';
        },
        validations: {
            old_pass: {
                required
            },
            repass: {
                sameAsPass: sameAs('pass')
            }
        }
    }
</script>

<style scoped>

</style>
